import {
  GET_CONTRACTS_BEGIN,
  GET_CONTRACTS_SUCCESS,
  GET_CONTRACTS_ERROR,
  GET_CONTRACT_BEGIN,
  GET_CONTRACT_SUCCESS,
  GET_CONTRACT_ERROR,
  OPT_IN_ERROR,
  OPT_IN_SUCCESS,
  OPT_IN_BEGIN,
} from "~/actions/contracts";
import { sentryWrappedException } from "~/utils/Utils";
import { Contract } from "~/components/Contract/constants";

const findContractIdxByCid = (contracts: Contract[], cid: number) =>
  contracts.findIndex((contract) => contract.cid === cid);

// @ts-expect-error
const contracts_reducer = (state, action) => {
  if (action.type === GET_CONTRACTS_BEGIN) {
    return {
      ...state,
      contractsLoading: true,
      contractsError: false,
    };
  }

  if (action.type === GET_CONTRACTS_SUCCESS) {
    const contracts = action.payload.contracts;
    const contracts_avaliable = action.payload.avaliable;
    return {
      ...state,
      contractsLoading: false,
      contracts,
      contracts_avaliable,
      contractsError: false,
    };
  }

  if (action.type === GET_CONTRACTS_ERROR) {
    return {
      ...state,
      contractsLoading: false,
      contractsError: true,
    };
  }

  if (action.type === GET_CONTRACT_BEGIN) {
    return {
      ...state,
      contractLoading: true,
      contractError: false,
    };
  }

  if (action.type === GET_CONTRACT_SUCCESS) {
    const contract = action.payload.contract;
    return {
      ...state,
      contractLoading: false,
      contract,
      contractError: false,
    };
  }

  if (action.type === GET_CONTRACT_ERROR) {
    return {
      ...state,
      contractLoading: false,
      contractError: true,
    };
  }

  if (action.type === OPT_IN_BEGIN) {
    const contractIdx = findContractIdxByCid(state.contracts, action.payload.cid);
    const contract = state.contracts[contractIdx];
    contract.stage = "OPTING_IN";
    return { ...state };
  }
  if (action.type === OPT_IN_SUCCESS) {
    const contractIdx = findContractIdxByCid(state.contracts, action.payload.cid);
    const contract = state.contracts[contractIdx];
    contract.stage = "OPTIN";
    return { ...state };
  }
  if (action.type === OPT_IN_ERROR) {
    const contractIdx = findContractIdxByCid(state.contracts, action.payload.cid);
    const contract = state.contracts[contractIdx];
    contract.stage = null;
    return { ...state };
  }
  // return state;
  const error = new Error(`No Matching "${action.type}" - action CONTRACTS_REDUCER type`);
  sentryWrappedException(error);
  throw error;
};

export default contracts_reducer;
